import { DropdownDivider, DropdownItem } from 'bold-ui'
import { DropdownButton } from 'components/dropdown'
import React from 'react'

export function AtividadeColetivaGruposTableDropdownMenu() {
  return (
    <DropdownButton>
      <DropdownItem>Editar grupo</DropdownItem>
      <DropdownItem>Inativar grupo</DropdownItem>
      <DropdownDivider />
      <DropdownItem type='danger'>Excluir grupo</DropdownItem>
    </DropdownButton>
  )
}
